// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"common":"4ef5a4ffc9a1645d76b1","feed-creation-page":"88eee93ce4c5ea401b44","feed-manager-page":"a530f756d5fb56beed5a"}[chunkId] + ".js";
};